import { Chip } from "@mui/material";
import { TalentIndustrialExperienceDto } from "../api/models/talent";
import ChipContainer from "./TalentChipContainer";

export type TalentIndustrialExperienceChipsProps = {
    industrialExperiences?: TalentIndustrialExperienceDto[]
    removeIndustrialExperience: (industrialExperienceId: string) => void
    isRemovingIndustrialExperience: boolean
}

const TalentIndustrialExperienceChips = ({
    industrialExperiences,
    removeIndustrialExperience,
    isRemovingIndustrialExperience,
}: TalentIndustrialExperienceChipsProps) => {
    if (isRemovingIndustrialExperience) {
        return (
            <p className="mt-2">Loading...</p>
        );
    }

    return (
        <ChipContainer className="pt-6">
            {(industrialExperiences ?? [])
                .sort((a, b) => (new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()))
                .map(industrialExperience => (
                    <Chip
                        key={`talent-industrial-experience-${industrialExperience.industrialExperienceId}`}
                        label={industrialExperience.industrialExperienceName}
                        onDelete={() => removeIndustrialExperience(industrialExperience.industrialExperienceId)}
                        variant="outlined"
                        color="secondary"
                        sx={{ marginRight: 1, marginBottom: 1 }}
                    />
                ))}
        </ChipContainer>
    );
};

export default TalentIndustrialExperienceChips;
